import React from "react";
import { Box, Typography } from "@mui/material";
import { useSystemTheme } from "context/SystemThemeContext";

const InstructionStep = React.memo(({ number, title, children, icon }) => {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  
  return (
    <Box sx={{ 
      mb: 2,
      display: 'flex',
      gap: 2,
      alignItems: 'flex-start'
    }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          minWidth: 28,
          borderRadius: '50%',
          backgroundColor: isDarkMode ? '#2d2d3f' : '#e0f7fa',
          color: '#219297',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '0.85rem',
          flexShrink: 0,
          transition: 'background-color 0.3s ease',
        }}
      >
        {icon || number}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography 
          variant="subtitle2"
          fontWeight="600" 
          sx={{ 
            color: isDarkMode ? '#e2e8f0' : '#333',
            mb: 0.5,
            fontSize: '0.9rem',
            transition: 'color 0.3s ease',
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: isDarkMode ? '#a0aec0' : '#666',
            fontSize: '0.85rem',
            lineHeight: 1.5,
            transition: 'color 0.3s ease',
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );
});

export default InstructionStep;